import { Routes, RouterModule } from '@angular/router';
import { RelacionDependenciaJefeComponent } from './relacion-dependencia-jefe.component';
import { NgModule } from '@angular/core';
import { RelacionJefeSedeComponent } from './relacion-jefe-sede.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';

const routes: Routes = [
    { path: '', component: RelacionDependenciaJefeComponent },
    { path: 'sede', component: RelacionJefeSedeComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class RelacionDependenciaJefeRouting { }
